module.exports = __webpack_public_path__ + "img/20180414165914.bbc74627.jpg";